import { useDataValue, useDataChange } from 'Simple/Data.js'

export function useOnClick(props) {
  let option = useDataValue({
    context: 'option',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'selected',
    path: 'type',
    viewPath: props.viewPath,
  })

  return function onClick() {
    if (option.isSelected || option.isDisabled) return
    return change(option.id)
  }
}
